import { Alert } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

export function AuditLogsIncompleteNotice() {
  const { t } = useTranslation('features', { useSuspense: false })

  return (
    <Alert.Root
      as="output"
      status="warning"
      size="sm"
      mb={4}
      data-testid="audit-logs-incomplete-notice"
    >
      <Alert.Indicator />
      <Alert.Title>{t('auditLogs.incompleteNotice')}</Alert.Title>
    </Alert.Root>
  )
}
